import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeM from '../views/gb/mobile.vue'
import Home from '../views/home.vue'
import path from 'path'
// import UAParser from 'ua-parser-js';
// const uaParser = new UAParser();
// const deviceInfo = uaParser.getResult();

// const isMobileDevice = deviceInfo.device.type === 'mobile';
Vue.use(VueRouter)

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

export const constRoutesPc = [
	{
		path: '/send-larger-files-on-gbwhatsapp',
		name: 'blog-3',
		meta: {
			appname: 'GBWhatsApp',
			title: 'How to Send Larger Files on GBWhatsApp？',
			keywords: 'send larger files',
			description: 'Step-by-step guide on how to send larger files on GBWhatsApp, including high-resolution videos, images, and documents. Learn tips for hassle-free file sharing.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappapk.org/send-larger-files-on-gbwhatsapp/'
				}
			]
		},
		component: () => import('@/views/blog-3.vue'),
	},
	{
		path: '/transform-your-chats-hidden-aesthetic-power-gbwhatsapp/',
		name: 'blog-4',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Transform Your Chats: The Hidden Aesthetic Power of GBWhatsApp',
			keywords: 'GBWhatsApp customization, GBWhatsApp themes, GBWhatsApp download',
			description: 'GBWhatsApp isn’t just about privacy — it’s about expression. Discover how custom themes, icons, and fonts can completely change your chatting experience.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappapk.org/transform-your-chats-hidden-aesthetic-power-gbwhatsapp/'
				}
			]
		},
		component: () => import('@/views/blog-4.vue'),
	},
	{
		path: '/group-chats-segregation/',
		name: 'blog-5',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Stay Organized with GBWhatsApp\'s Group Chats Segregation Feature',
			keywords: 'Group Chats Segregation',
			description: 'Keep personal and group chats organized with GBWhatsApp\'s Group Chats Segregation feature and boost focus for a smoother messaging experience.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappapk.org/group-chats-segregation/'
				}
			]
		},
		component: () => import('@/views/blog-5.vue'),
	},
	{
		path: '/gb-whatsapp-calls-not-working/',
		name: 'blog-7',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GB WhatsApp Calls Not Working: Fix Guide',
			keywords: 'GB WhatsApp calls not working, GB WhatsApp voice call not working, GB WhatsApp video call not working',
			description: 'Having trouble making or receiving calls on GB WhatsApp? Learn how to fix voice and video call issues caused by connection, permissions, battery settings, VPN, cache, or app version problems.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappapk.org/gb-whatsapp-calls-not-working/'
				}
			]
		},
		component: () => import('@/views/blog-7.vue'),
	},
	{
		path: '/gb-whatsapp-keeps-crashing/',
		name: 'blog-8',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GB WhatsApp Keeps Crashing? 7 Easy Ways to Fix It',
			keywords: 'GB WhatsApp keeps crashing, GB WhatsApp crash fix, GB WhatsApp closing by itself',
			description: 'GB WhatsApp keeps crashing or closing by itself? Find out why it happens and try simple fixes for cache, storage, permissions, updates, and more.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappapk.org/gb-whatsapp-keeps-crashing/'
				}
			]
		},
		component: () => import('@/views/blog-8.vue'),
	},
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GB WhatsApp APK Download 2026 Latest Version 18.80',
			keywords: 'gb whatsapp, gbwhatsapp, gb whatsapp download',
			description: 'GBWhatsApp is the best modified version and all banned problems are fixed in this version. Download GB WhatsApp APK file to get the latest update.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappapk.org/'
				}
			]
		},
		component: Home,
	},
	{
		path: '/download/',
		name: 'en-download',
		pathToRegexpOptions: { strict: true },
		meta: {
			appname: 'GBWhatsApp',
			title: 'Download Page of GB WhatsApp APK Pro Latest Version',
			keywords: 'gbwhatsapp download, gb whatsapp download, download gbwhatsapp',
			description: 'Enter this download Page of GB WhatsApp APK to get the latest version installed on your Android phone. We\'ll udpdate new version in time.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappapk.org/download/'
				}
			]
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/download',
		redirect: '/download/',
	},
	{
		path: '/how-to-fix-location-not-working-in-gbwhatsapp/',
		name: 'how-to-fix-location-not-working-in-gbwhatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Fix Location Not Working in GBWhatsApp`,
			keywords: 'fix location not working in GBWhatsApp',
			description: `Fix GBWhatsApp location not working issues by checking phone location services, permissions, GPS signal, Google Play Services, and updating the GBWhatsApp app version.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gbappapk.org/how-to-fix-location-not-working-in-gbwhatsapp/`,
				},
			],
		},
		component: () => import('@/views/blog-6.vue'),
	},
	{
		path: '/blog/',
		name: 'en-blogs',
		meta: {
			appname: 'GBWhatsApp',
			title: `Blogs`,
			keywords: 'blogs',
			description: `We write news, tips and tricks to help you use GB WhatsApp in high efficiency. Start to read these blogs now!`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappapk.org/blog/'
				}
			]
		},
		component: () => import('@/views/blogs.vue'),
	},
	// {
	// 	path: '/how-change-fonts-on-gbwhatsapp',
	// 	name: 'en-blog1',
	// 	meta: {
	// 		appname: 'GBWhatsApp',
	// 		title: `How to Change Fonts on GBWhatsApp (2026 Guide)`,
	// 		keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
	// 		description: `Learn how to change fonts on GBWhatsApp in a few simple steps. Customize your chat style with unique font styles and sizes for a fresh WhatsApp look.`,
	// 		link: [
	// 			{
	// 				rel: 'canonical',
	// 				href: 'https://gbappapk.org/how-change-fonts-on-gbwhatsapp/'
	// 			}
	// 		]
	// 	},
	// 	component: () => import('@/views/blog1.vue'),
	// },

	// {
	// 	path: '/privacy',
	// 	name: 'privacy',
	// 	meta: {
	// 		appname: 'GBWhatsApp',
	// 		title: `Privacy Policy – GB WhatsApp Info Site`,
	// 		keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
	// 		description: `Read this privacy policy content. We are not GB WhatsApp developers; we only provide information for educational purposes.`,
	// 		link: [
	// 			{
	// 				rel: 'canonical',
	// 				href: 'https://gbappapk.org/privacy/'
	// 			},
	// 		],
	// 		noindex: true
	// 	},
	// 	component: () => import('@/views/privacy.vue'),
	// },
	// {
	// 	path: '/about-us',
	// 	name: 'about-us',
	// 	meta: {
	// 		appname: 'GBWhatsApp',
	// 		title: `About GB WhatsApp and Our Site`,
	// 		keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
	// 		description: `We build this site for users to download GB WhatsApp safely and for free. Learn more about us on this page.`,
	// 		link: [
	// 			{
	// 				rel: 'canonical',
	// 				href: 'https://gbappapk.org/about-us/'
	// 			}
	// 		],
	// 		noindex: true
	// 	},
	// 	component: () => import('@/views/about.vue'),
	// },
	// {
	// 	path: '/transfer',
	// 	name: 'transfer',
	// 	meta: {
	// 		appname: 'GBWhatsApp',
	// 		link: [
	// 			{
	// 				rel: 'canonical',
	// 				href: 'https://gbappapk.org/transfer/'
	// 			}
	// 		]
	// 	},
	// 	component: () => import('@/views/transfer.vue'),
	// 	},
	{
		path: '/how-to-fix-gbwhatsapp-banned-problem',
		name: 'blog-1',
		meta: {
			appname: 'GBWhatsApp',
			title: 'How to Fix GB WhatsApp Banned Problem',
			keywords: 'Fix GB WhatsApp Banned Problem',
			description: 'Learn why GB WhatsApp gets banned, how to fix temporary and permanent bans (including reinstalling the latest version, contacting support, using a new number), and tips to prevent future bans. Solutions for common unban issues are also covered.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappapk.org/how-to-fix-gbwhatsapp-banned-problem/'
				}
			]
		},
		component: () => import('@/views/blog-1.vue'),
	},
	{
		path: '/is-gbwhatsapp-safe',
		name: 'blog-2',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Is GBWhatsApp Safe? What You Need to Know Before Installing',
			keywords: 'GBWhatsApp safe, is GBWhatsApp safe',
			description: 'Curious about GBWhatsApp\'s safety? Learn how to install the official version safely, steer clear of fake apps, and make the most of its unique features without risks',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappapk.org/is-gbwhatsapp-safe/'
				}
			]
		},
		component: () => import('@/views/blog-2.vue'),
	},
	{
		path: '/disclaimer',
		name: 'disclaimer',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Disclaimer',
			keywords: 'gbwhatsapp disclaimer, gb whatsapp disclaimer, disclaimer',
			description: 'GB WhatsApp APKs are provided for educational purposes only. We are not affiliated with WhatsApp or Meta. Use it at your own risk.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbappapk.org/disclaimer/'
				}
			],
			noindex: true
		},
		component: () => import('@/views/disclaimer.vue'),
	},

]

// export const constRoutesM = [
// 	{
// 		path: '/',
// 		name: 'Home',
// 		meta: {
// 			appname: 'GBWhatsApp',
// 			topLogo: require('@/assets/gb/GB_new_icon_small@2x.png'),
// 			footLogo: require('@/assets/gb/icon_GB_new@2x.png'),
// 			showBreadcrumb: true,
// 			showTelegram: true,
// 		},
// 		// component: HomeM,
// 	},
// 	{
// 		path: '/download',
// 		name: 'download',
// 		meta: {
// 			appname: 'GBWhatsApp',
// 			topLogo: require('@/assets/gb/GB_new_icon_small@2x.png'),
// 			footLogo: require('@/assets/gb/icon_GB_new@2x.png'),
// 			showBreadcrumb: false,
// 		},
// 		component: () => import('@/components/download.vue'),
// 	},
// ]

let routes = []
// if (isMobileDevice) {
// 	routes = constRoutesM
// }
// if (!isMobileDevice) {
// 	routes = constRoutesPc
// }

routes = constRoutesPc
export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
